import * as React from 'react';
import CompFourInput from './components/FourInput';
import CompFourHotSearch from './components/FourHotSearch';
import CompFourNoIdeas from './components/FourNoIdeas';
import CompFourSuggestion from './components/FourSuggestion';
import CompFourHome from './components/FourHome';
import type { IHomeDataItem, IHonorDataItem } from './model';
import CompFourFooter from './components/FourFooter';
import ReoI18n, { useTranslation } from '@/modules/ReoI18n';
import { getRecommendationsByKey } from '@/api/client/recommend';
import type { ICustomizeRecommendData } from '@/interface/recommend';
import { getCDNPath } from '@/utils/function/getCDNPath';
import type { IPageNotFoundFetchRes } from './fetch';
import i18n from 'i18next';
import styles from './index.module.less';
import classNames from 'classnames';
import '@reolink-web/components.basic/dist/style.css';
import CompHeader from './render-header';
import CompFooterEntry from './render-footer';
import { globalAppContext } from '@/shared/globalAppContext';
const CompPageNotFound: React.FC<{ ctx: IPageNotFoundFetchRes; }> = (props) => {
    const context = React.useContext(globalAppContext);
    const reoI18n = React.useMemo(() => {
        const reoI18n = new ReoI18n();
        reoI18n.init({
            i18nInstance: i18n,
            currentLang: props.ctx.lang,
        });
        return reoI18n;
    }, [props.ctx.lang]);

    reoI18n.loadResource(
        ['page-not-found', 'reolink-header', 'reolink-footer', 'subscribe'],
        {
            ...props.ctx.i18nPackage,
        },
        props.ctx.lang ?? 'en',
    );
    const { t } = useTranslation();
    const [searchRecommendData, setSearchRecommendData] = React.useState<ICustomizeRecommendData>({
        data: [],
        type: 'customize',
    });
    const [recommendProduct, setRecommendProduct] = React.useState<ICustomizeRecommendData>({
        data: [],
        type: 'customize',
    });
    const getRecommendationData = React.useCallback(async () => {
        try {
            const res = await getRecommendationsByKey({
                keys: ['notFoundPageAd', 'notFoundPageRecommend'],
                lang: '',
            });
            if (res) {
                if (!Array.isArray(res.notFoundPageRecommend)) {
                    setSearchRecommendData(res.notFoundPageRecommend as ICustomizeRecommendData);
                }
                if (!Array.isArray(res.notFoundPageAd)) {
                    setRecommendProduct(res.notFoundPageAd as ICustomizeRecommendData);
                }
            }
            else {
                console.error('no recommendation data');
            }
        }
        catch {
            console.error('get recommendation data error');
        }
    }, []);

    React.useEffect(() => {
        getRecommendationData().catch(console.error);
    }, [getRecommendationData]);
    const homeDataList: IHomeDataItem[] = React.useMemo(() => {
        return [1, 2, 3].map((item) => ({
            title: t('page-not-found:home-data-title-' + item),
            link: t('page-not-found:home-data-link-' + item),
            image: getCDNPath(t('page-not-found:home-data-image-' + item)),
        }));
    }, [t]);
    const honorDataList: IHonorDataItem[] = React.useMemo(() => {
        return [1, 2, 3, 4].map((item) => ({
            title: t('page-not-found:honor-data-title-' + item),
            desc: t('page-not-found:honor-data-desc-' + item),
            image: getCDNPath(t('page-not-found:honor-data-image-' + item)),
        }));
    }, [t]);
    return (
        <>
            {context.meta.clientFeatures.useHeader ? <CompHeader { ...props } /> : null}
            <div
                id="main"
                className={ classNames(styles['error-404-container']) }
                role="main">
                <section className={ classNames(styles['error-404'], styles['not-found'], 'mt', 'mb') }>
                    <div>
                        <CompFourInput />
                        <CompFourHotSearch { ...searchRecommendData } />
                        <CompFourNoIdeas />
                        <div className={ styles['pink-background'] }>
                            <CompFourSuggestion recommendProduct={ recommendProduct } />
                            <CompFourHome data={ homeDataList } />
                        </div>
                        <CompFourFooter
                            title={ t('page-not-found:honor-title') }
                            honorData={ honorDataList } />
                    </div>
                </section>
            </div>
            {context.meta.clientFeatures.useFooter ? <CompFooterEntry { ...props } /> : null}
        </>
    );
};

export default CompPageNotFound;
